// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3JY2r","error":"Textarea_error__3MylV","readonly":"Textarea_readonly__1hAeF","disabled":"Textarea_disabled__VOc28"};